/**
 * Responsibility: where each kind of document lives, in the browser's copy.
 *
 * **These names must match `core/firestore/paths.py` exactly.** They are the
 * one thing in this system that genuinely is duplicated across the two
 * languages, because a path is a string in a URL rather than a type anything
 * can generate from. A mismatch does not fail loudly: the rules deny an unknown
 * path, so the page renders empty and correct-looking.
 *
 * `OWNED_COLLECTIONS` there and `COLLECTIONS` here are the pair to check if
 * anything is ever added.
 */

/** Top-level collection holding every account. */
export const USERS = 'users';

export const HOLDINGS = 'holdings';
export const VALUES = 'values';
export const HISTORY = 'history';
export const LIKES = 'likes';
export const SEARCHES = 'searches';
export const TOPICS = 'topics';
export const BINS = 'bins';
export const CHANNELS = 'channels';
export const WATCH_SUBS = 'watchSubs';
export const GRADING_LIST = 'gradingList';
export const SIGNAL_STATE = 'signalState';
export const SETTINGS = 'settings';
export const SUMMARY = 'summary';

/** Fixed document ids, so they can be read without a query. */
export const SETTINGS_DOC = 'preferences';
export const SUMMARY_DOC = 'current';

/** `users/{uid}` */
export function userPath(uid: string): string {
  return `${USERS}/${uid}`;
}

/** `users/{uid}/{name}` */
export function subcollection(uid: string, name: string): string {
  return `${USERS}/${uid}/${name}`;
}

/** `users/{uid}/{name}/{id}` */
export function documentPath(uid: string, name: string, id: string): string {
  return `${USERS}/${uid}/${name}/${id}`;
}
